// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Su2oE","icon":"styles_icon__2zdid"};